const adminEmails = [
  "kansli@fobo.se",
  "odlaren@kagus.nu",
  "layout@kagus.nu",
  "alfred@uix.se"
];

const editors = [
  { email: 'kerstin@angvik.se' , prefix: '/norrkoping' },
  { email: 'dahnson@gmail.com' , prefix: '/eksjo' },
  { email: 'helena@nees.se', prefix: '/stockholm' },
  { email: 'marita.joy@hotmail.com', prefix: '/stockholm' },
  { email: 'aforssblad@hotmail.com', prefix: '/stockholm' },
  { email: 'liselotte.larsson@live.se', prefix: '/skane'},
  { email: 'lena_nylund@hotmail.com', prefix: '/sundsvall'},
  { email: 'tove.palin@gmail.com', prefix: '/sundsvall'},
  { email: 'marek.rolenec@for.se', prefix: '/linkoping'},
];

export function isAdmin(email: string | null): boolean {
  if (!email) return false; // Om e-post är null, inte admin
  return adminEmails.includes(email.toLowerCase()); // Kontrollera mot listan, case-insensitiv
}

export function isEditor(email: string | null, path: string): boolean {
  if (!email) return false;
  return editors.some(
    editor => editor.email.toLowerCase() === email.toLowerCase() &&
    (
      editor.prefix.toLowerCase() === path.toLowerCase()
      || path.toLowerCase().startsWith(editor.prefix.toLowerCase() + '/')
    )
  );
}

export function editorPrefixes(email: string | null): string[] {
  if (!email) return [];
  return editors.filter(editor => editor.email.toLowerCase() === email.toLowerCase()).map(editor => editor.prefix).sort();
}